module.exports = __webpack_public_path__ + "static/media/warningPin.369699fb.png";